module.exports = __webpack_public_path__ + "static/media/Claremont Dr, San Bruno, CA3.3389cba8.jpg";